import { DialogActions, Modal, Typography } from '@mui/material';
import type { ComponentProps, ReactNode } from 'react';
import React from 'react';

export const StyledModal: React.FC<ComponentProps<typeof Modal>> = ({ children, ...props }) => (
  <Modal className="styled-modal" {...props}>
    {children}
  </Modal>
);

export const HelpText: React.FC<ComponentProps<typeof Typography>> = ({ children, ...props }) => (
  <Typography className="modal-help-text" {...props}>
    {children}
  </Typography>
);

export const StepContent: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className="modal-step-content">{children}</div>
);

export const StyledDialogActions: React.FC<ComponentProps<typeof DialogActions>> = ({ children, ...props }) => (
  <DialogActions className="modal-actions-styled" {...props}>
    {children}
  </DialogActions>
);

export const SectionTitle: React.FC<ComponentProps<typeof Typography>> = ({ children, ...props }) => (
  <Typography className="modal-section-title" {...props}>
    {children}
  </Typography>
);

export const ModalContent: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className="modal-content-wrapper">{children}</div>
);

export const ModalHeader: React.FC<{ children: ReactNode; id?: string }> = ({ children, id }) => (
  <h3 className="modal-section-title text-center" id={id}>
    {children}
  </h3>
);

export const ModalText: React.FC<{ children: ReactNode }> = ({ children }) => (
  <p className="modal-message">{children}</p>
);

export const ButtonContainer: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className="modal-button-container">{children}</div>
);
